// Footer: collapse/expand accordion columns based on viewport.
// Driven by matchMedia, not resize: on mobile the URL bar showing/hiding while
// scrolling fires resize, which used to slam shut whatever the user had opened.
(function () {
  var accordions = document.querySelectorAll('.ft-col--accordion details');
  if (!accordions.length) return;

  var mobile = window.matchMedia('(max-width: 740px)');

  function syncAccordions(isMobile) {
    accordions.forEach(function (d) {
      if (isMobile) {
        d.removeAttribute('open');
      } else {
        d.setAttribute('open', '');
      }
    });
  }

  syncAccordions(mobile.matches);

  // Fires only when the breakpoint is actually crossed
  if (mobile.addEventListener) {
    mobile.addEventListener('change', function (e) { syncAccordions(e.matches); });
  } else if (mobile.addListener) {
    mobile.addListener(function (e) { syncAccordions(e.matches); });
  }
})();

// Footer: live store-hours widget (Google Places, with localStorage cache + fallback schedule)
(function () {
  var el = document.getElementById('ft-boutique-status');
  if (!el) return;
  var textEl = el.querySelector('.ft-card__status-text');
  var placeId = el.dataset.placeId;
  var apiKey = el.dataset.apiKey;

  if (!placeId || !apiKey) { runFallback(); return; }

  var CACHE_KEY = 'boutique-status-v1';

  function cacheExpiresAt(hours) {
    var t = hours.openNow ? hours.nextCloseTime : hours.nextOpenTime;
    return t ? new Date(t).getTime() : (Date.now() + 60 * 60 * 1000);
  }

  function renderHours(hours) {
    if (!hours) { runFallback(); return; }
    if (hours.openNow) {
      el.removeAttribute('data-closed');
      var closeText = hours.nextCloseTime ? (' \xb7 do ' + warsawHM(hours.nextCloseTime)) : '';
      textEl.textContent = 'Otwarte' + closeText;
    } else {
      el.setAttribute('data-closed', '');
      textEl.textContent = hours.nextOpenTime ? nextOpenLabel(hours.nextOpenTime) : 'Zamknięte';
    }
  }

  try {
    var cached = JSON.parse(localStorage.getItem(CACHE_KEY) || 'null');
    if (cached && cached.expiresAt && Date.now() < cached.expiresAt) {
      renderHours(cached.hours);
      return;
    }
  } catch (e) {}

  fetch(
    'https://places.googleapis.com/v1/places/' + placeId + '?key=' + apiKey,
    { headers: { 'X-Goog-FieldMask': 'currentOpeningHours' } }
  )
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var hours = data.currentOpeningHours;
      try { localStorage.setItem(CACHE_KEY, JSON.stringify({ hours: hours, expiresAt: cacheExpiresAt(hours) })); } catch (e) {}
      renderHours(hours);
    })
    .catch(runFallback);

  function warsawHM(isoStr) {
    return new Date(isoStr).toLocaleTimeString('pl-PL', {
      timeZone: 'Europe/Warsaw', hour: '2-digit', minute: '2-digit', hour12: false
    });
  }

  function warsawDateStr(d) {
    return d.toLocaleDateString('sv-SE', { timeZone: 'Europe/Warsaw' });
  }

  function warsawDow(d) {
    var s = d.toLocaleDateString('en-US', { timeZone: 'Europe/Warsaw', weekday: 'short' });
    return ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(s);
  }

  function nextOpenLabel(isoStr) {
    var openDate = new Date(isoStr);
    var now = new Date();
    var hm = warsawHM(isoStr);
    if (warsawDateStr(openDate) === warsawDateStr(now)) return 'Otwarte dziś od ' + hm;
    var tomorrow = new Date(now); tomorrow.setDate(tomorrow.getDate() + 1);
    if (warsawDateStr(openDate) === warsawDateStr(tomorrow)) return 'Otwarte jutro od ' + hm;
    var preps = ['w niedz.', 'w pon.', 'we wt.', 'w śr.', 'w czw.', 'w pt.', 'w sob.'];
    return 'Otwarte ' + preps[warsawDow(openDate)] + ' od ' + hm;
  }

  function runFallback() {
    var wdOpen   = parseInt(el.dataset.weekdayOpen)   || 11;
    var wdClose  = parseInt(el.dataset.weekdayClose)  || 18;
    var satOpen  = parseInt(el.dataset.saturdayOpen)  || 11;
    var satClose = parseInt(el.dataset.saturdayClose) || 15;
    var specialDays = [];
    try { specialDays = JSON.parse(el.dataset.specialDays || '[]'); } catch (e) {}
    var now = new Date();
    var utcMs = now.getTime() + (now.getTimezoneOffset() * 60000);
    var month = now.getUTCMonth() + 1;
    var offset = (month >= 4 && month <= 10) ? 7200000 : 3600000;
    var local = new Date(utcMs + offset);
    var h = local.getHours(), dow = local.getDay();
    function pad2(n) { return n < 10 ? '0' + n : '' + n; }
    var todayStr = local.getFullYear() + '-' + pad2(local.getMonth() + 1) + '-' + pad2(local.getDate());
    var tomorrowLocal = new Date(local); tomorrowLocal.setDate(tomorrowLocal.getDate() + 1);
    var tomorrowStr = tomorrowLocal.getFullYear() + '-' + pad2(tomorrowLocal.getMonth() + 1) + '-' + pad2(tomorrowLocal.getDate());
    function findDay(dateStr) {
      for (var i = 0; i < specialDays.length; i++) {
        if (specialDays[i].date === dateStr) return specialDays[i];
      }
      return null;
    }
    var today    = findDay(todayStr);
    var tomorrow = findDay(tomorrowStr);
    function toMin(str) {
      if (!str) return -1;
      var p = str.split(':'); return parseInt(p[0]) * 60 + (parseInt(p[1]) || 0);
    }
    function fmtH(h) { return h + ':00'; }
    var cur = h * 60 + local.getMinutes();
    var open = false, closeLabel;
    if (today && today.closed) {
      open = false;
    } else if (today && today.open && today.close) {
      open = cur >= toMin(today.open) && cur < toMin(today.close);
      closeLabel = today.close;
    } else if (dow >= 1 && dow <= 5) {
      open = cur >= wdOpen * 60 && cur < wdClose * 60; closeLabel = fmtH(wdClose);
    } else if (dow === 6) {
      open = cur >= satOpen * 60 && cur < satClose * 60; closeLabel = fmtH(satClose);
    }
    if (open) {
      el.removeAttribute('data-closed');
      textEl.textContent = 'Otwarte \xb7 do ' + closeLabel;
    } else {
      el.setAttribute('data-closed', '');
      var days = ['', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'];
      var todayOpenLabel = (today && !today.closed && today.open) ? today.open : fmtH(dow === 6 ? satOpen : wdOpen);
      var nextDay, nextOpenLabel;
      function tomorrowOpenLabel(regularH) {
        return (tomorrow && !tomorrow.closed && tomorrow.open) ? tomorrow.open : fmtH(regularH);
      }
      if ((dow >= 1 && dow <= 6 || today) && cur < toMin(todayOpenLabel)) {
        nextDay = 'dziś'; nextOpenLabel = todayOpenLabel;
      } else if (dow >= 1 && dow <= 4) {
        nextDay = days[dow + 1]; nextOpenLabel = tomorrowOpenLabel(wdOpen);
      } else if (dow === 5) {
        nextDay = 'Sob'; nextOpenLabel = tomorrowOpenLabel(satOpen);
      } else {
        nextDay = 'Pon'; nextOpenLabel = fmtH(wdOpen);
      }
      var prep = nextDay === 'Wt' ? 'we' : 'w';
      var prefix = nextDay === 'dziś' ? 'Otwarte dziś od' : 'Otwarte ' + prep + ' ' + nextDay + ' od';
      textEl.textContent = prefix + ' ' + nextOpenLabel;
    }
  }
})();

// Slideshow: swap mobile/desktop video on resize, pause autoplay while a video is visible
(function () {
  var MOBILE_BREAKPOINT = 740;

  function getVisibleVideo(slide) {
    var isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    if (isMobile) {
      var mobileWrapper = slide.querySelector('.slideshow__video-mobile');
      if (mobileWrapper) return mobileWrapper.querySelector('[data-slide-video]');
    }
    return slide.querySelector('[data-slide-video]');
  }

  function initSlideVideos(slideshowEl) {
    if (typeof Flickity === 'undefined') return false;
    var flkty = Flickity.data(slideshowEl);
    if (!flkty) return false;

    var autoPlayEnabled = !!flkty.options.autoPlay;
    var activeVideo = null;
    var advanceTimer = null;

    function fallbackDelay() {
      return typeof flkty.options.autoPlay === 'number' ? flkty.options.autoPlay : 6000;
    }

    function scheduleFallback(ms) {
      clearTimeout(advanceTimer);
      advanceTimer = setTimeout(onFallback, Math.max(ms, 500));
    }

    // Safety net: if 'ended' never arrives (autoplay blocked, video errored),
    // move on anyway — but never cut short a video that is still playing.
    function onFallback() {
      advanceTimer = null;
      if (activeVideo && !activeVideo.paused && !activeVideo.ended) {
        scheduleFallback(isFinite(activeVideo.duration)
          ? (activeVideo.duration - activeVideo.currentTime) * 1000 + 500
          : fallbackDelay());
        return;
      }
      advance();
    }

    function advance() {
      releaseActiveVideo();
      flkty.next(true);
    }

    function releaseActiveVideo() {
      if (advanceTimer) {
        clearTimeout(advanceTimer);
        advanceTimer = null;
      }
      if (activeVideo) {
        activeVideo.removeEventListener('ended', advance);
        activeVideo = null;
      }
    }

    // Video slide: stop the carousel timer, play the clip once, then go to the next slide.
    function playOnceThenAdvance(video) {
      activeVideo = video;
      video.loop = false;
      video.addEventListener('ended', advance);
      scheduleFallback(isFinite(video.duration) && video.duration > 0
        ? video.duration * 1000 + 1000
        : fallbackDelay());
      var played = video.play();
      if (played && played.catch) {
        played.catch(function () {
          if (activeVideo === video) scheduleFallback(fallbackDelay());
        });
      }
    }

    // On slide change: rewind every video, then either resume the carousel timer
    // (image slide) or hand pacing over to the video on the active slide.
    function onSelect() {
      releaseActiveVideo();
      slideshowEl.querySelectorAll('[data-slide-video]').forEach(function (v) {
        v.pause();
        v.currentTime = 0;
        if (v.hasAttribute('loop')) v.loop = true;
      });

      var currentSlide = flkty.selectedElement;
      var video = currentSlide && getVisibleVideo(currentSlide);
      if (!video) {
        if (autoPlayEnabled) flkty.playPlayer();
        return;
      }

      flkty.stopPlayer();
      if (!autoPlayEnabled || flkty.slides.length < 2) {
        var loopPlay = video.play();
        if (loopPlay && loopPlay.catch) loopPlay.catch(function () {});
        return;
      }
      playOnceThenAdvance(video);
    }

    flkty.on('select', onSelect);
    onSelect();

    // On resize, swap to the correct video (mobile/desktop) for the active slide
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var currentSlide = flkty.selectedElement;
        if (!currentSlide) return;
        var allVideos = currentSlide.querySelectorAll('[data-slide-video]');
        if (allVideos.length < 2) return;
        if (getVisibleVideo(currentSlide) !== activeVideo) onSelect();
      }, 200);
    });

    return true;
  }

  function init() {
    document.querySelectorAll('.js-slideshow').forEach(function (el) {
      if (!initSlideVideos(el)) {
        var attempts = 0;
        var timer = setInterval(function () {
          if (initSlideVideos(el) || ++attempts >= 20) clearInterval(timer);
        }, 100);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-measure all Flickity slideshows after full page load so slide 0's
  // adaptiveHeight is computed with real fonts and the scrollbar present.
  window.addEventListener('load', function () {
    document.querySelectorAll('.js-slideshow').forEach(function (el) {
      var flkty = Flickity.data(el);
      if (flkty) flkty.resize();
    });
  });
})();

// Boutique-split: drag/click carousel for the image column
(function () {
  document.querySelectorAll('.js-bs-track').forEach(function (track) {
    var section = track.closest('[data-section-id]');
    if (!section || track.children.length < 2) return;

    var prev = section.querySelector('.js-bs-prev');
    var next = section.querySelector('.js-bs-next');
    var dotsEl = section.querySelector('.js-bs-dots');

    var total = track.children.length;
    var current = 0;

    function goTo(n) {
      current = (n + total) % total;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (dotsEl) {
        var dots = dotsEl.querySelectorAll('.js-bs-dot');
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === current);
          d.setAttribute('aria-selected', String(i === current));
        });
      }
    }

    if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
    if (next) next.addEventListener('click', function () { goTo(current + 1); });

    if (dotsEl) {
      dotsEl.querySelectorAll('.js-bs-dot').forEach(function (d, i) {
        d.addEventListener('click', function () { goTo(i); });
      });
    }

    var startX = 0;
    var dragging = false;

    function dragStart(x) { startX = x; dragging = true; track.style.transition = 'none'; }
    function dragEnd(x) {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      var diff = startX - x;
      goTo(Math.abs(diff) > 50 ? current + (diff > 0 ? 1 : -1) : current);
    }

    track.addEventListener('touchstart', function (e) { dragStart(e.touches[0].clientX); }, { passive: true });
    track.addEventListener('touchend', function (e) { dragEnd(e.changedTouches[0].clientX); });
    track.addEventListener('mousedown', function (e) { dragStart(e.clientX); e.preventDefault(); });
    window.addEventListener('mouseup', function (e) { dragEnd(e.clientX); });

    var interval = parseInt(section.dataset.autoplayInterval, 10) || 0;
    if (interval > 0) {
      var timer = setInterval(function () { goTo(current + 1); }, interval);
      track.addEventListener('mousedown', function () { clearInterval(timer); });
      track.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
    }
  });
})();
